import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-text',
  imports: [CommonModule, TabsModule, LineBreakPipe],
  templateUrl: './text.component.html',
})
export class TextComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  activeTab = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }

      // Ensure activeTab is valid
      if (this.items.length > 0 && this.activeTab >= this.items.length) {
        this.activeTab = 0;
      }

    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any, active: boolean = false): string {
    return buildPublicExperienceStyles(type, style, active);
  }

  handleTabChange(index: number): void {
    this.activeTab = index;
  }
}
